<template>
  <div class="check-answer" v-on:scroll="handleScroll">
    <Header></Header>
    <div class="content" v-if="JSON.stringify(detailObj) !== '{}'">
      <h1 class="title">{{ detailObj.ExamPaperName }}</h1>
      <div class="tab" :class="isFixed ? 'topFixed' : ''">
        <div style="display: flex;align-items: center;">
          <a href="javascript:;" v-for="(item, index) in detailObj.ExamPartList" :key="index" @click="partclick(index)" :class="activepartIndex == index ? 'active' : ''">{{ item.ExamPartName }}</a>
        </div>
        <label style="margin-right: 10px;">用时：{{ diffTime(new Date(detailObj.ExamRecord.StartTime), new Date(detailObj.ExamRecord.EndTime)) }}</label>
      </div>
      <div class="main">
        <div class="left-mian" style="width:68%;border: 1px solid #dcdcdc;">
          <div v-for="(item, index) in list" :id="'mytpe_' + index" :key="index">
            <p class="partTitle">{{ item.ExamPartName }}</p>
            <div v-for="(it, num) in item.ExamItemList" :key="num" :id="'questionbox' + it.ExamItemId" class="questionbox">
              <div class="problem" style="padding: 8px;background-color: #fff;">
                <div>
                  <p style="display: flex;margin: 20px 10px;" v-if="it.ExamBigTitleName"><span v-html="it.ExamBigTitleName"></span></p>
                  <p style="display: flex;margin: 20px 10px;"><span v-html="it.Stem"></span></p>
                  <div style="display: flex;margin: 10px;" v-if="it.OptionA">A.<span v-html="it.OptionA"></span></div>
                  <div style="display: flex;margin: 10px;" v-if="it.OptionB">B.<span v-html="it.OptionB"></span></div>
                  <div style="display: flex;margin: 10px;" v-if="it.OptionC">C.<span v-html="it.OptionC"></span></div>
                  <div style="display: flex;margin: 10px;" v-if="it.OptionD">D.<span v-html="it.OptionD"></span></div>
                  <div style="display: flex;margin: 10px;" v-if="it.OptionE">E.<span v-html="it.OptionE"></span></div>
                  <div style="display: flex;margin: 10px;" v-if="it.OptionF">F.<span v-html="it.OptionF"></span></div>
                  <div class="open" style="background: #eeeeee;margin: 0 -8px;line-height: 45px;height: 45px;padding: 0 25px; overflow: hidden; zoom: 1;position: relative;">
                    <div>
                      <label>参考答案：{{ it.Answer }}</label>
                      <label style="margin-left: 20px;">我的答案：{{ it.UserAnswer }}</label>
                    </div>
                    <span class="tag-wrap">
                      <!-- <a href="javascript:;" class="repair" onclick="CreateFeedBack(139,763,18377)">纠错</a> -->
                      <a href="javascript:;" class="openA" @click="open(index, num)">展开解析</a>
                    </span>
                  </div>
                  <div class="answer" :style="{ display: it.isopen ? 'block' : 'none' }">
                    <div>
                      <label>解析：</label>
                      <div class="analysis" v-html="it.Analysis">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-mian" style="width:30%" :class="isFixed ? 'fixPos' : ''">
          <h5><label>答题卡</label><span><el-checkbox v-model="checked" label="只看错题" name="type" @change="changeClick"></el-checkbox></span></h5>
          <div class="mainLeft">
            <div class="otitle" v-for="(item, index) in rightList" :key="index" :id="'part' + index">
              <p class="titPart">{{ item.ExamPartName }}</p>
              <div>
                <a href="javascript:;" :class="{ 'mark': it.isclick, 'red': it.UserAnswer && it.UserAnswer != it.Answer, 'blue': it.UserAnswer && it.UserAnswer == it.Answer, }" class="myitem" :id="'part' + index + '_ques' + num" @click="SelectQues(item, index, it)" v-for="(it, num) in item.list" :key="num">{{ it.SortNo }}</a>
              </div>
            </div>
          </div>
          <div class="tip">
            <span>
              <a href="javascript:;" class="correct"></a>
              <label>正确</label>
            </span>
            <span>
              <a href="javascript:;" class="error"></a>
              <label>错误</label>
            </span>
            <span>
              <a href="javascript:;" class="no"></a>
              <label>未做</label>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
export default {
  name: 'CheckExamAnswer',
  components: {
    Header
  },
  data() {
    return {
      topFixed: false,
      checked: false,
      isFixed: false,
      detailObj: {},
      paperId: '',
      recordId: '',
      activepartIndex: 0,
      list: [],
      rightList: [],
      copylist: [],
    }
  },
  mounted() {
    this.paperId = this.$route.query.examID
    this.recordId = this.$route.query.recordId
    this.$api.HJCheckExam({ recordId: this.recordId, paperId: this.paperId }).then(res => {
      if (res.Success) {
        this.detailObj = res.Data
        this.list = this.detailObj.ExamPartList.sort((a,b)=>{
          return a.ExamPartId-b.ExamPartId
        })
        this.list.map(item => {
          let obj = {
            ExamPartName: item.ExamPartName,
            list: this.convertToObjectArray(item.ExamItemList).flat()
          }
          this.rightList.push(obj)
          this.copylist.push(obj)
        })
      }

      console.log(this.rightList,this.list)
    })
  },
  methods: {
    //监听元素滚动距离
    handleScroll(e) {
      if (e.target.scrollTop > 240) {
        this.isFixed = true
      } else this.isFixed = false
    },
    //计算时间距离
    diffTime(date1, date2) {
      const msPerMinute = 60 * 1000;
      const msPerSecond = 1000;
      const diffInMs = Math.abs(date2 - date1);
      const minutes = Math.floor(diffInMs / msPerMinute);
      const seconds = Math.floor((diffInMs % msPerMinute) / msPerSecond);

      return `${minutes}分${seconds}秒`;
    },
    convertToObjectArray(arr) {
      const result = [];
      for (let i = 0; i < arr.length; i++) {
        const obj = arr[i];
        if (obj.ChildExamItemList.length > 0) {
          const children = this.convertToObjectArray(obj.ChildExamItemList);
          result.push(children);
        } else {
          result.push(obj);
        }
      }
      return result;
    },
    partclick(index) {
      this.activepartIndex = index
      window.location.hash = '#mytpe_' + index;
      document.querySelector('#mytpe_' + index).scrollIntoView({ behavior: 'smooth' });

    },
    //只看错题
    changeClick() {
      if (this.checked) {
        this.rightList = this.copylist.map(item => {
          return {
            ...item,
            list: item.list.filter(obj => obj.UserAnswer && obj.UserAnswer != obj.Answer)
          };
        });
      } else this.rightList = this.copylist
    },
    SelectQues(item, index, it) {
      console.log(item, index, it)
      this.rightList.forEach(item => {
        item.list.forEach(it => {
          this.$set(it, 'isclick', false)
        })
      })
      this.$set(it, 'isclick', true)
      console.log(it)
      window.location.hash = '#questionbox' + it.ExamItemId;
      document.querySelector('#questionbox' + it.ExamItemId).scrollIntoView({ behavior: 'smooth' });
    },
    // isPositiveOrZero(value) {
    //   return value > 0 || value === 0;
    // },
    open(index, num, n) {
      if (n) {
        if (n.Description) {
          this.$set(this.list[index].ExamItemList[num].ChildExamItemList[n], 'isopen', true)
        }
      } else {

        this.$set(this.list[index].ExamItemList[num], 'isopen', !this.list[index].ExamItemList[num].isopen)
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.header-wrap {
  position: relative !important;
}

.check-answer {
  height: 100%;
  overflow: scroll;

  .content {
    margin: 0 auto;
    zoom: 1;
    width: 1200px;

    .title {
      height: 81px;
      background: #e5e5e5;
      position: relative;
      margin: 30px auto;
      line-height: 81px;
      float: none;
      font-weight: normal;
      font-size: 20px;
      font-size: 24px;
      color: #666666;
      text-align: center;
      line-height: 81px;
    }

    .tab {
      margin-top: 45px;
      height: 48px;
      background: #eeeeee;
      overflow: hidden;
      zoom: 1;
      width: 100%;
      position: relative;
      display: flex;
      justify-content: space-between;

      label {
        line-height: 48px;
        top: 0;
        font-size: 16px;
        color: #666666;
      }

      a {
        text-decoration: none;
        padding: 0 10px;
        color: #555;
        font-size: 14px;
        line-height: 48px;
      }

      .active {
        background: #17b7f2;
        color: #fff;
      }
    }

    .topFixed {
      position: fixed;
      top: 0px;
      z-index: 99;
      margin-top: 0;
      margin-right: 0px;
      max-width: 1200px;
      // width: 360px !important;
    }

    .fixPos {
      position: fixed;
      top: 65px;
      margin-left: 840px;
      width: 360px !important;
    }
  }

  .main {
    min-height: 100%;
    height: auto !important;
    overflow: hidden;
    zoom: 1;
    padding-top: 15px;
    position: relative;

    .left-mian {
      float: left;

      ::v-deep tr td {
        border: 1px solid #b3b3b3 !important;
        white-space: nowrap;
        text-align: center;
      }

      ::v-deep table {
        margin-top: 10px;
        border: 1px solid #000000;
        border-collapse: collapse;
      }

      .partTitle {
        background: #e5e5e5;
        font-weight: bold;
        font-size: 16px;
        color: #666;
        height: 45px;
        line-height: 45px;
        padding-left: 30px;

        // .problem {
        //   padding: 8px;
        //   background-color: #fff;
        // }
      }

      .open {
        background: #eeeeee;
        margin: 0 -8px;
        line-height: 45px;
        height: 45px;
        padding: 0 25px;
        overflow: hidden;
        display: flex;
        justify-content: space-between;

        * {
          font-size: 16px;
          color: #666666;
        }

        .tag-wrap {
          font-size: 14px;
          color: #666666;
          display: flex;

          a {
            margin-right: 33px;
            padding-left: 24px;
            background-repeat: no-repeat;
            background-position: 0 center;
            text-align: center;
            margin-bottom: 25px;
            display: block;
            font-size: 20px;
            color: #666666;
            margin-right: -1px;
          }

          .openA {
            background-image: url(../assets/img/open.png);
            padding-left: 0;
            padding-right: 19px;
            background-position: right center;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 20px;
          }
        }
      }

      .answer {
        font-size: 16px;
        border-bottom: 1px solid #dcdcdc;
        position: relative;
        color: #666666;
        line-height: 28px;
        background: #fff;
        padding: 28px;
        zoom: 1;

        div {
          overflow: hidden;
          margin-bottom: 15px;
        }
      }
    }

    .right-mian {
      border: 1px solid #dcdcdc;
      float: right;

      h5 {
        background: #e5e5e5;
        font-size: 16px;
        color: #666;
        height: 45px;
        line-height: 45px;
        padding: 0 30px;
        overflow: hidden;
        zoom: 1;

        label {
          float: left;
        }

        span {
          float: right;
        }
      }

      .mainLeft {
        padding: 0 30px;
        height: 396px;
        overflow-y: auto;
        border-right: 1px solid #e4e4e4;

        .titPart {
          font-size: 14px;
          color: #17b7f2;
          line-height: 45px;
          font-weight: normal;
          margin-bottom: 0px
        }

        a {
          width: 22px;
          height: 24px;
          display: inline-block;
          border: 1px solid #e5e5e5;
          color: #666666;
          text-align: center;
          line-height: 24px;
          font-size: 12px;
          margin: 0 6px 12px 0;
          text-decoration: none;
        }

        .red {
          background: #ff5858;
          color: #fff;
        }

        .blue {
          background: #17b7f2;
          color: #ffffff;
        }

        .mark {
          background-image: url(../assets/img/btn.png);
          background-position: 11px -631px;
          background-repeat: no-repeat;
          z-index: 999;
        }
      }

      .tip {
        padding: 10px 30px;
        border-top: 1px solid #dcdcdc;
        overflow: hidden;
        zoom: 1;

        span {
          float: left;
          margin-right: 22px;

          a {
            display: inline-block;
            width: 22px;
            height: 24px;
            border: 1px solid #e5e5e5;
            background: #fff;
            font-size: 12px;
            color: #666666;
            text-align: center;
            line-height: 24px;
            margin: 0 6px 12px 0;
            float: left;
            text-decoration: none;
          }

          .correct {
            background: #17b7f2;
            color: #ffffff;
          }

          .error {
            background: #ff5858;
            color: #fff;
          }
        }
      }
    }
  }

  ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    height: 50px;
    background-color: #b8b8b8;
    -webkit-border-radius: 6px;
    outline: 2px solid #fff;
    outline-offset: -2px;
    border: 2px solid #fff;
    opacity: 0.5;
  }

  ::-webkit-scrollbar-track-piece {
    background-color: #fff;
    -webkit-border-radius: 0;
  }
}</style>